<div class="row"
#loadingContainer
      usbLoadingSplash
      [appLoading]="appLoading"
      [fullscreen]="true"
      [component]="'body_reservation'"
>


  <div class="col-8">
    <div *ngFor="let items of itineraryItems | groupBy: 'categoryName'; let i = index">
      <div *ngFor="let item of items.value | orderBy: 'title'; let i = index">
        <div *ngIf="i==0 || (itineraryItems[i-0]!=undefined && (itineraryItems[i-0].categoryName!=item.categoryName))">
          <span class="title text-uppercase d-flex align-items-center" *ngIf="(item.categoryName=='HOTELS' || item.categoryName=='PARKS')">
            <span class="circle-icon mr-3" style="color: #000000">
              <i class="icons-hotel"></i>
            </span> Selecciona habitación para pasajeros
          </span>
          <span class="title text-uppercase" *ngIf="item.categoryName=='PTHEMES'"><i
              class="icon-small icon-pthemes iconstart  text-center pr-3"></i>Select ptheme for passengers</span>
          <span class="title text-uppercase d-flex align-items-center" *ngIf="item.categoryName=='TRANSPORTS'">
            <span class="circle-icon mr-3" style="color: #000000">
              <i class="icons-transport"></i>
            </span>
            Seleccionar traslado para pasajeros</span>
          <span class="title text-uppercase" *ngIf="item.categoryName=='DISNEY'">
            <i class="icon-small icon-disney iconstart  text-center pr-3"></i>Select disney for passengers</span>

          <span class="title text-uppercase d-flex align-items-center" *ngIf="item.categoryName=='RENT-A-CAR'">
            <span class="circle-icon mr-3">
              <i class="icons-cars"></i>
            </span>
            Seleccionar coches para pasajeros</span>
          <span class="title text-uppercase d-flex align-items-center" *ngIf="item.categoryName=='TOURS' && item.subCategoryId===6">
            <span class="circle-icon mr-3">
              <svg [ngClass]="{'icon-status-reserved': item.categoryName=='TOURS' && item.subCategoryId===6}"
              version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="25px" height="25px" viewBox="0 0 45.908 45.908" style="enable-background:new 0 0 45.908 45.908;"
                        xml:space="preserve">
                      <g>
                        <g>
                          <path d="M20.833,0.141C20.198-0.107,19.5-0.024,18.937,0.36c-0.563,0.384-0.886,1.022-0.886,1.703v4.743h-7.062
                            c-1.547,0-2.8,1.253-2.8,2.8v32.037c0,0.75,0.549,1.388,1.291,1.499l18.279,2.743c0.595,0.09,1.18-0.084,1.635-0.478
                            c0.456-0.393,0.699-0.963,0.699-1.563v-1.567h5.205c1.338,0,2.422-1.084,2.422-2.421V7.629c0-0.544-0.334-1.032-0.84-1.229
                            L20.833,0.141z M22.879,33.32c-0.113,0.13-0.275,0.202-0.444,0.202c-0.034,0-0.068-0.004-0.103-0.01l-11.186-1.968
                            c-0.204-0.035-0.374-0.175-0.448-0.367c-0.075-0.192-0.042-0.411,0.084-0.574l6.242-8.037c0.313-0.402,0.792-0.631,1.291-0.632
                            c0.094,0,0.189,0.008,0.284,0.025c0.597,0.104,1.086,0.532,1.272,1.108l3.124,9.684C23.06,32.949,23.016,33.164,22.879,33.32z
                            M27.229,30.824c-0.129,0.147-0.327,0.218-0.521,0.185l-2.229-0.393l-2.303-7.141l-0.028-0.087l0.288-0.371
                            c0.354-0.458,0.933-0.68,1.502-0.58c0.569,0.102,1.037,0.507,1.214,1.059l2.189,6.785C27.4,30.47,27.358,30.676,27.229,30.824z
                            M34.04,39.332h-3.948v-25.34c0-1.021-0.733-1.889-1.744-2.041L13.666,9.746h19.831c0.709,0,1.281,0.573,1.281,1.281v27.57
                            C34.776,39.003,34.447,39.332,34.04,39.332z"/>
                        </g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      </svg>
            </span>
            Seleccionar experiencia para pasajeros</span>
            <!-- <span *ngIf="item.categoryName === 'TOURS'"> -->
              <!-- {{getItem(item)}} -->
            <!-- </span> -->
            <span class="title text-uppercase d-flex align-items-center" *ngIf="item.categoryName=='TOURS' && item.subCategoryId===9">

            <span class="circle-icon mr-3">
              <svg  class="svg-tickets"  [ngClass]="{
                      'icon-status-reserved': item.categoryName=='TOURS' && item.subCategoryId===9 }"xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 48 48" >
                  <path d="M 15 3 C 12.256343 3 10 5.256343 10 8 L 10 9 L 13 9 L 13 8 C 13 6.877657 13.877657 6 15 6 C 16.122343 6 17 6.877657 17 8 L 17 9 L 13 9 L 13 17.5 C 13 18.33 13.67 19 14.5 19 C 15.33 19 16 18.33 16 17.5 L 16 13.5 C 16 12.67 16.67 12 17.5 12 C 18.33 12 19 12.67 19 13.5 L 19 17.5 C 19 19.98 16.98 22 14.5 22 C 12.02 22 10 19.98 10 17.5 L 10 9 L 9.5 9 C 6.47 9 4 11.47 4 14.5 L 4 28.5 C 4 31.53 6.47 34 9.5 34 L 38.5 34 C 41.53 34 44 31.53 44 28.5 L 44 14.5 C 44 11.47 41.53 9 38.5 9 L 20 9 L 20 8 C 20 5.256343 17.743657 3 15 3 z M 24.5 14 L 35.5 14 C 36.33 14 37 14.67 37 15.5 C 37 16.33 36.33 17 35.5 17 L 24.5 17 C 23.67 17 23 16.33 23 15.5 C 23 14.67 23.67 14 24.5 14 z M 24.5 20 L 35.5 20 C 36.33 20 37 20.67 37 21.5 C 37 22.33 36.33 23 35.5 23 L 24.5 23 C 23.67 23 23 22.33 23 21.5 C 23 20.67 23.67 20 24.5 20 z M 24.5 26 L 32.5 26 C 33.33 26 34 26.67 34 27.5 C 34 28.33 33.33 29 32.5 29 L 24.5 29 C 23.67 29 23 28.33 23 27.5 C 23 26.67 23.67 26 24.5 26 z M 14.119141 37 L 30.189453 44.490234 C 30.939453 44.840234 31.72 45.009766 32.5 45.009766 C 34.57 45.009766 36.560234 43.830078 37.490234 41.830078 L 39.75 37 L 14.119141 37 z"/>
                </svg>
            </span>
            Seleccionar ticket para pasajero</span>
          <span class="title text-uppercase d-flex align-items-center" *ngIf="item.categoryName=='INSURANCE'">
             <span class="circle-icon mr-3">

                                    <svg class="svg-hotels" [ngClass]="{
                            'icon-status-reserved': item.categoryName=='INSURANCE' }"
                      version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 298.182 298.182"  width="25px" height="25px"  style="enable-background:new 0 0 298.182 298.182;" xml:space="preserve">
                    <g>
                      <path  d="M124.172,0c-3.115,0-5.893,0.245-8.212,0.805C97.082,5.36,64.32,32.051,55.423,41.162
                        c-4.271,4.376-2.577,13.114,5.925,13.114c3.675,0,8.62-1.632,14.905-5.952c11.489-7.898,25.556-11.376,38.407-11.376
                        c10.448,0,20.092,2.297,26.903,6.383c3.374,2.024,3.363,2.701,1.406,2.701c-3.931,0-15.718-2.728-23.707-2.728
                        c-3.93,0-6.94,0.66-7.645,2.63c-3.254,9.114,9.363,12.048,22.557,17.388c9.66,3.911,21.447,6.863,32.674,6.863
                        c4.681,0,9.3-0.514,13.591-1.684c19.487-5.314,32.575-9.314,37.575-10.614V6.743c-9,2.95-17.312,5.778-22.602,5.778
                        C185.705,12.521,146.41,0,124.172,0z"/>
                      <path   d="M125.939,242.182h-1.032c-3.751,0-7.892-3.963-7.892-7.87v-56.694c0-3.882,3.641-7.032,7.016-7.072l14.379,0.004
                        c-5.797-4.499-9.325-10.646-9.325-18.346c0-9.206,5.462-17.26,13.259-21.021h-19.529c8.443-5.435,14.041-14.91,14.041-25.697
                        c0-8.89-3.8-16.889-9.859-22.472c-5.442-5.015-12.708-8.08-20.69-8.08c-0.756,0-1.503,0.037-2.245,0.091
                        c-15.824,1.15-28.306,14.343-28.306,30.461c0,10.787,5.597,20.262,14.04,25.697H69.384h-0.376h-1.993v0.139
                        c-4,0.715-9,4.305-9,8.928v75.72c0,5.176,5.816,10.214,10.993,10.214h0.376c4.466,0,7.631-3.486,8.631-7.768v65.887
                        c0,7.651,6.853,13.881,14.503,13.881h0.442c7,0,12.771-5.196,13.705-11.94c0.933,6.744,6.705,11.94,13.702,11.94h0.442
                        c4.061,0,7.205-1.787,10.205-4.571v-55.491C130.015,240.082,128.343,242.182,125.939,242.182z"/>
                      <path   d="M180.114,80.77c-7.633,5.554-12.6,14.552-12.6,24.715c0,10.787,5.598,20.262,14.041,25.697h-19.43
                        c7.784,3.747,13.164,11.757,13.164,20.952c0,7.698-3.77,13.918-9.566,18.417l14.672,0.031c4.5,0.403,6.62,3.848,6.62,7.52v57.175
                        c0,3.908-2.722,7.904-6.632,7.904H180.1c-2.761,0-5.085-2.334-7.085-4.686v55.612c3,2.499,6.727,4.074,10.546,4.074h0.442
                        c6.997,0,12.77-5.196,13.703-11.94c0.933,6.744,6.705,11.94,13.704,11.94h0.442c7.649,0,13.162-6.23,13.162-13.881v-65.887
                        c1,4.281,5.506,7.768,9.972,7.768h0.376c5.176,0,9.652-5.038,9.652-10.214v-75.72c0-4.846-4-8.564-9-9.018v-0.048h-0.652h-0.376
                        h-20.412c8.443-5.435,14.04-14.91,14.04-25.697c0-16.106-12.463-29.291-28.27-30.458c-0.754-0.056-1.513-0.094-2.28-0.094
                        C191.355,74.933,185.154,77.102,180.114,80.77z"/>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    <g>
                    </g>
                    </svg>

             </span>
              Seleccionar asistencia para pasajeros</span>

          <span class="title text-uppercase d-flex align-items-center" *ngIf="item.categoryName=='FLIGHTS'">
            <span class="circle-icon mr-3">
              <img width="25px" src="../../../assets/img/app/categories-search-box/AEREO.svg" alt="">
            </span>
            Seleccionar vuelo para pasajeros</span>

          <span class="title text-uppercase" *ngIf="item.categoryName=='CRUISES'"><i
              class="icon-small icon-crucero iconstart  text-center pr-3"></i>Select cabin for passengers</span>
        </div>
        <accordion [closeOthers]="true" class="mb-4">
          <accordion-group [isOpen]="i == 0 ? true : false">
            <div class="row" accordion-heading>
              <div class="col-12 d-flex justify-content-between">
                <div class="d-flex flex-column p-3 product-select-data"
                [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                  <div class="name-hotel">
                    <div class="pull-left title-producto" *ngIf="(item.categoryName=='HOTELS' || item.categoryName=='PARKS')">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px" style="margin-right: 8px"></object>
                      {{item.payloadUpdate.products[0].destination}} > <span class="name"
                      [ngStyle]="{'color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">{{item.title | truncate : 40 : "  "}}</span>
                    </div>
                    <div class="pull-left title-producto" style="color:#00d397" *ngIf="item.categoryName=='PTHEMES'">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"></object>
                      {{item.payloadUpdate.products[0].destination}} > <span class="name" style="color:#00d397"></span> </div>
                    <div class="pull-left title-producto-transport" style="margin-left:.7em !important;" *ngIf="item.categoryName=='TRANSPORTS'">

                          <div><p class="mb-0 name">{{item?.vehicle?.name}}</p></div>

                         <!-- - {{item.vehicle.name}} -->

                    </div>
                    <div class="pull-left title-producto" *ngIf="item.categoryName=='DISNEY'">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"></object>
                      Disney -
                      <span class="name" style="color:#00d397">{{item.hotel.title | truncate : 40 : "  "}}
                        {{i+1}}</span></div>
                    <div class="pull-left title-producto" *ngIf="item.categoryName=='RENT-A-CAR'">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"  style="margin-right: 8px"></object>
                      {{item.payloadUpdate.products[0].destination}} > <span class="name"
                        style="color:#00d397">{{item.title | truncate : 40 : "  "}} </span>
                    </div>
                    <div class="pull-left title-producto" *ngIf="item.categoryName=='INSURANCE'">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"  style="margin-right: 8px"></object>
                     {{item.form.begin}} > {{item.payloadUpdate.products[0].destination}} <span class="name" style="color:#00d397">{{item.title}}
                      </span></div>
                    <div class="pull-left title-producto" *ngIf="item.categoryName=='FLIGHTS'">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"  style="margin-right: 8px"></object>
                      {{item.origin}} > {{item.destinationAirport}} <span class="name" style="color:#00d397">
                        {{item.itinerary?.[0]?.options?.[0]?.segments?.[0]?.airline?.name | truncate : 40 : "  "}} </span>
                    </div>
                    <div class="pull-left title-producto" *ngIf="item.categoryName=='CRUISES'">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"  style="margin-right: 8px"></object>
                      {{item.payloadUpdate.products[0].destination}} > <span class="name" style="color:#00d397">
                      </span></div>
                    <div class="pull-left title-producto" *ngIf="item.categoryName=='TOURS' && item.subCategoryId === 6">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"  style="margin-right: 8px"></object>
                      {{item.payloadUpdate.products[0].destination}} > <span class="name" style="color:#00d397">
                        {{item.title | truncate : 40 : "  "}} </span>
                    </div>
                    <div class="pull-left title-producto" *ngIf="item.categoryName=='TOURS' && item.subCategoryId === 9">
                      <object type="image/svg+xml" data='/assets/img/app/little-icons/placeholder_verd.svg' width="15px"
                        height="15px"  style="margin-right: 8px"></object>
                      {{item.payloadUpdate.products[0].destination}} > <span class="name" style="color:#00d397">
                        {{item.title | truncate : 40 : "  "}} </span>
                    </div>
                    <span class="pull-right" style="display: flex; justify-content: space-between; align-items: center;">
                      <p *ngIf="(item.categoryName=='HOTELS' || item.categoryName=='PARKS')" style="font-size: 14px; font-weight:600; text-transform: uppercase;margin-bottom: 0;">{{item.roomType}}</p>
                      <p *ngIf="item.categoryName=='RENT-A-CAR'" style="font-size: 14px; font-weight:600; text-transform: uppercase;margin-bottom: 0;">{{item.type}} - {{item.type_definition}}</p>
                      <p *ngIf="item.categoryName=='TOURS' && item.subCategoryId === 6" style="font-size: 14px; font-weight:600; text-transform: uppercase;margin-bottom: 0;">{{item.experience?.option_name}}</p>
                      <p *ngIf="item.categoryName=='TOURS' && item.subCategoryId === 9" style="font-size: 14px; font-weight:600; text-transform: uppercase;margin-bottom: 0;">{{item.ticket?.option_name}}</p>
                      <p *ngIf="item.categoryName=='TRANSPORTS'" style="font-size: 14px; font-weight:600; text-transform: uppercase;margin-bottom: 0;">{{item.transferType}}</p>
                       <p *ngIf="item.categoryName=='INSURANCE'" style="font-size: 14px; font-weight:600; text-transform: uppercase;margin-bottom: 0;">{{item?.trip?.tripType}}</p>
                      <p *ngIf="item.categoryName=='FLIGHTS'" style="font-size: 14px; font-weight:600; text-transform: uppercase;margin-bottom: 0;">{{item.selectedFare?.fareCode || item.itinerary?.[0]?.options?.[0]?.segments?.[0]?.cabin?.category}}</p>
                      <i class="icon-down ml-3" style="margin-top: .1em"></i>
                    </span>
                  </div>
                  <div class="" style="margin-left:1.6em;font-size: small;">
                    <!-- <p class="m-0 text-uppercase font-detail" *ngIf="(item.categoryName=='HOTELS' || item.categoryName=='PARKS')">
                      {{item.roomType}}</p> -->
                    <p class="mt-1 font-detail" *ngIf="(item.categoryName === 'HOTELS' || item.categoryName === 'PARKS') || item.categoryName === 'TOURS' || item.categoryName === 'RENT-A-CAR' || item.categoryName === 'INSURANCE'">
                      <span *ngIf="item.categoryName === 'TOURS'">INICIO: {{item.arrivalDate !== 'To be defined'? (item.arrivalDate | date: 'dd MMM YY') : item.arrivalDate}} </span>
                      <span *ngIf="item.categoryName !== 'TOURS'">CHECK-IN: {{item.arrivalDate !== 'To be defined'? (item.arrivalDate | date: 'dd MMM YY') : item.arrivalDate}} </span>
                        <span *ngIf="item.categoryName!='TOURS'" class="ml-2 mr-2">|</span>
                      <span *ngIf="item.categoryName!='TOURS'"> CHECK-OUT: {{item.departureDate !== 'To be defined'? (item.departureDate | date: 'dd MMM YY') : item.departureDate}}
                      </span>
                    </p>
                    <p class="mt-1 font-detail" *ngIf="item.categoryName === 'FLIGHTS'">
                      <span>SALIDA: {{item.arrivalDate | date: 'dd MMM YY'}} </span>
                      <ng-container *ngIf="item.returnDate">
                        <span class="ml-2 mr-2">|</span>
                        <span>REGRESO: {{item.returnDate | date: 'dd MMM YY'}}</span>
                      </ng-container>
                    </p>
                    <div class="mt-1 font-detail d-flex flex-column" style="gap: .5em;" *ngIf="item.categoryName === 'TRANSPORTS'">
                      <div class="d-flex">

                        <div class="d-flex flex-column">
                          <div><p class="mb-1">PICKUP:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{extractNameTransport(item.formTransport.firstOrigin, 'origin', item.payload[0])}}<span >{{extractAddressType(item.formTransport.firstOrigin, 'origin', item.payload[0])}}</span></p></div>
                          <div><p class="mb-0">DROPOFF: {{extractNameTransport(item.formTransport.firstDestination, 'destination', item.payload[0])}}<span>{{extractAddressType(item.formTransport.firstDestination, 'destination', item.payload[0])}}</span></p></div>
                        </div>
                      </div>
                      <p class="mb-0 mt-1">INICIO:&nbsp;&nbsp;&nbsp;{{item.arrivalDate | date: 'dd MMM YY'}} ({{item.payload[0].transfers.pickupTime}} hs. - {{getMessageFirstTime(item.payload[0].transfers.pickupTime, 'origin')}})</p>
                    </div>
                    <div *ngIf="(item.categoryName === 'HOTELS' || item.categoryName === 'PARKS')" class="mt-1 m-0 font-detail-2 d-flex align-items-end">
                      <i class="icono-night mr-1"></i>
                      {{item.nights}} noches
                      <i class="icono-adult ml-3 mr-1"></i>
                      {{item.paxAdults + (item.paxAdults > 1 ? ' Adultos' : ' Adulto')}}
                      <i class="icono-child ml-3 mr-1"></i>
                      {{item.paxChildren +  ' Niños'}} {{getAgesInItem(item)}}
                    </div>
                    <div *ngIf="item.categoryName === 'TOURS'" class="mt-1 m-0 font-detail-2 d-flex align-items-end">
                      <i class="icono-adult mr-1"></i>
                      {{item.paxAdults + (item.paxAdults > 1 ? ' Adultos' : ' Adulto')}}
                      <i class="icono-child ml-3 mr-1"></i>
                      {{item.paxChildren +  ' Niños'}}  {{getAgesInItem(item)}}
                    </div>

                    <div *ngIf="item.categoryName === 'TRANSPORTS'" class="mt-2 m-0 font-detail-2 d-flex align-items-end">
                      <i class="icono-suitcases mr-1"></i>
                      {{item.vehicle.bag.maxBag}} max.
                      <i class="icono-adult ml-3 mr-1"></i>
                      {{item.paxAdults + (item.paxAdults > 1 ? ' Adultos' : ' Adulto')}}
                      <i class="icono-child ml-3 mr-1"></i>
                      {{item.paxChildren +  ' Niños'}} {{getAgesInItem(item)}}
                    </div>

                    <div *ngIf="item.categoryName === 'FLIGHTS'" class="mt-2 m-0 font-detail-2 d-flex align-items-center">
                      <i class="icono-adult mr-1"></i>
                      {{item.paxAdults + (item.paxAdults > 1 ? ' Adultos' : ' Adulto')}}
                      <i class="icono-child ml-3 mr-1"></i>
                      {{item.paxChildren +  ' Niños'}} {{getAgesInItem(item)}}
                      <button
                              *ngIf="!item?.extraPrivateLabel"
                              type="button"
                              class="btn btn-sm ml-3"
                              style="border: 1px solid #00d398; color: #00a67a; border-radius: 50rem; padding: .2rem 1rem; font-size: 12px;"
                              (click)="openFlightSeatMap(item)">
                        Ver mapa de asientos
                      </button>
                    </div>
                    <p class="mt-1 m-0 font-detail-2 d-flex align-items-end">
                      <span
                            *ngIf="checkProductConfirm(item)"
                            [ngClass]="{'status-ok': checkProductConfirm(item), 'status-pending': !checkProductConfirm(item)}"
                            style="position: absolute; right: 3em;">Listo</span>
                      <span *ngIf="!checkProductConfirm(item)"
                            [ngClass]="{'status-ok': checkProductConfirm(item), 'status-pending': !checkProductConfirm(item)}"
                            style="position: absolute; right: 3em;">Pendiente</span>
                    </p>
                  </div>
                </div>
                <!-- <div class="d-flex justify-content-between p-3 product-status"
                  [ngClass]="{'status-ok': checkProductConfirm(item), 'status-pending': !checkProductConfirm(item)}">
                  <object *ngIf="!checkProductConfirm(item)" type="image/svg+xml" data='/assets/img/app/little-icons/timer_bco.svg'
                    width="30px" height="30px"></object>
                  <span *ngIf="checkProductConfirm(item)" class="icon-check"></span>
                  <span class="text-white" *ngIf="checkProductConfirm(item)">Listo</span>
                  <span class="text-white" *ngIf="!checkProductConfirm(item)">Pendiente</span>
                </div> -->
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <form (ngSubmit)="_onSubmit()" [formGroup]="_form" novalidate>
                  <div class="row px-3">
                    <div class="px-0"
                      [ngClass]="{'col-3' : item.categoryName=='RENT-A-CAR', 'col-4' : item.categoryName !='TRANSPORTS' || item.categoryName !='RENT-A-CAR'}">
                      <div class="form-group">
                        <label *ngIf="item.categoryName=='RENT-A-CAR'">Conductor</label>
                        <label *ngIf="item.categoryName!=='RENT-A-CAR'">Pasajeros</label>
                        <select class="form-control custom-select" #pax (change)="setPaxToItem(pax.value, item, $event, i);">
                          <option disabled value="null" selected="true">Seleccione los pasajeros</option>
                          <ng-container *ngIf="item.categoryName !== 'INSURANCE' && item.paxChildren === 0; else showOptions">
                            <!-- Si item.paxChildren es igual a 0 y pax.relation_ship es "Adult", muestra las opciones de adultos -->
                             <ng-container *ngFor="let pax of paxAdultsArr; let i = index;">
                               <option
                                       *ngIf="!paxAlreadySelectedInItem(pax, item.id) && ageValidInItem(pax, item)"
                                       [value]="pax.document_number"
                                       [attr.data-idUnique]="pax.idUnique"
                                       [attr.data-name]="pax.first_name"
                                       [attr.data-last_name]="pax.last_name"
                                       [attr.data-relation_ship]="pax.relation_ship"
                                       [attr.data-gender]="pax.gender"
                                       [attr.data-birth_date]="pax.birth_date"
                                       [attr.data-age]="pax.age"
                                       [attr.data-title]="pax.title"
                                       [attr.data-document_type_id]="pax.document_type_id"
                                       [attr.data-address]="pax.address"
                                       [attr.data-country_id]="pax.country_id"
                                       [attr.data-phone_code]="pax.phone_code"
                                       [attr.data-city]="pax.city"
                                       [attr.data-phone]="pax.phone"
                                       [attr.data-phone_2]="pax.phone_2"
                                       [attr.data-client_id]="pax.clientId"
                                       [attr.data-state_id]="pax.state_id"
                                       [attr.data-paxListIndex]="pax.paxListIndex"
                                       [attr.data.type]="pax.type">
                                 {{pax.first_name}} {{pax.last_name}} - Adulto {{pax?.age ? "(" + pax?.age + " años)" : '' }}
                               </option>
                             </ng-container>
                          </ng-container>
                          <ng-template #showOptions>
                            <!-- Si item.paxChildren no es igual a 0 o pax.relation_ship no es "Adult", muestra las opciones de paxes como de costumbre -->
                             <ng-container *ngFor="let pax of paxes; let i = index;">
                               <option
                                       *ngIf="!paxAlreadySelectedInItem(pax, item.id) && ageValidInItem(pax, item)"
                                       [value]="pax.document_number"
                                       [attr.data-idUnique]="pax.idUnique"
                                       [attr.data-name]="pax.first_name"
                                       [attr.data-last_name]="pax.last_name"
                                       [attr.data-gender]="pax.gender"
                                       [attr.data-relation_ship_catalogue_id]="pax.relation_ship_catalogue_id"
                                       [attr.data-birth_date]="pax.birth_date"
                                       [attr.data-age]="pax.age"
                                       [attr.data-title]="pax.title"
                                       [attr.data-document_type_id]="pax.document_type_id"
                                       [attr.data-address]="pax.address"
                                       [attr.data-country_id]="pax.country_id"
                                       [attr.data-phone_code]="pax.phone_code"
                                       [attr.data-phone]="pax.phone"
                                       [attr.data-phone_2]="pax.phone_2"
                                       [attr.data-city]="pax.city"
                                       [attr.data-client_id]="pax.clientId"
                                       [attr.data-state_id]="pax.state_id"
                                       [attr.data-paxListIndex]="pax.paxListIndex"
                                       [attr.data-type]="pax.type">
                                 {{pax.first_name}} {{pax.last_name}} - {{pax.type == 'children' ? 'Niño' : 'Adulto'}}  {{pax?.age ? "(" + pax?.age + " años)" : '' }}
                               </option>
                             </ng-container>
                          </ng-template>
                        </select>
                      </div>
                    </div>
                    <div class="col-8 px-1" *ngIf="item.categoryName=='TOURS' && item.subCategoryId === 6 && getQuestionsHotelRefer(item)">
                      <div class="form-group">
                        <label for="Hotel">
                          {{getHotelSelectionMode(item) ? 'Seleccione un hotel' : 'Escriba el nombre del hotel y seleccione de la lista'}}
                        </label>

                        <ng-container *ngIf="getHotelForm(item) as hotelForm">
                          <form [formGroup]="hotelForm">

                            <!-- MODO SELECTOR (hoteles predefinidos) -->
                            <ng-container *ngIf="getHotelSelectionMode(item) && hotelsNameArr && hotelsNameArr.length > 0">
                              <select type="select"
                                      formControlName="destination"
                                      class="form-control custom-select btn-usb-rp element-config-passenger"
                                      [ngClass]="{'is-invalid': hotelForm.get('destination').invalid && hotelForm.get('destination').touched}"
                                      style="height: 38px !important"
                                      (change)="onHotelSelectedFromSelect($event.target.value, hotelForm)"
                                      id="destination">
                                <option value="null" disabled>Elija una opción</option>
                                <ng-container *ngFor="let hotel of hotelsNameArr">
                                  <option [value]="hotel">
                                    {{hotel}}
                                  </option>
                                </ng-container>
                              </select>

                              <!-- Mensajes de error para el select - CORREGIDO -->
                              <div *ngIf="hotelForm.get('destination').invalid && hotelForm.get('destination').touched"
                                  class="invalid-feedback d-block">
                                <div *ngIf="hotelForm.get('destination').hasError('required')">
                                  Por favor, seleccione un hotel de la lista
                                </div>
                              </div>

                              <!-- Botón para cambiar a modo búsqueda -->
                              <p class="mr-1 mb-0 mt-1"
                                [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                                style="font-family: 'Rubik';font-size: 12px;cursor:pointer; text-align: end;"
                                (click)="changeSelectHotel(item)">
                                Elegir otro hotel
                              </p>
                            </ng-container>

                            <!-- MODO BÚSQUEDA (autocomplete) -->
                            <ng-container *ngIf="!getHotelSelectionMode(item) || !hotelsNameArr || hotelsNameArr.length === 0">
                              <input
                                name="destino"
                                matInput
                                maxlength="20"
                                class="form-control input-search-box"
                                [ngClass]="{'is-invalid': hotelForm.get('destination').invalid && hotelForm.get('destination').touched}"
                                style="background-color: white;height: 38px !important"
                                #destinationInput
                                formControlName="destination"
                                placeholder="Escriba el nombre del hotel"
                                [matAutocomplete]="autoDestination">

                              <mat-autocomplete #autoDestination="matAutocomplete" [displayWith]="displayFn"
                                (optionSelected)="onHotelSelectedFromAutocomplete($event.option.value, hotelForm)">

                                <ng-container *ngIf="destinationOptions | async as options">
                                  <ng-container *ngFor="let optionItem of options">
                                    <ng-container *ngIf="optionItem.type === 'hotel'">
                                      <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="optionItem.hotels && optionItem.hotels.length > 0">
                                        <div class="d-flex justify-content-between">
                                          <div class="d-flex align-items-center" style="gap: 0.25em;">
                                            <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px;">
                                            <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Hotel</span>
                                          </div>
                                          <div>
                                            <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{optionItem.hotels.length}} resultados</span>
                                          </div>
                                        </div>
                                      </mat-option>
                                      <ng-container *ngFor="let hotel of optionItem.hotels">
                                        <mat-option [value]="hotel">
                                          <div style="margin-left: 2.4em;">
                                            <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">{{ capitalize(hotel.name) }},
                                            <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">
                                              {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? ',' : '' }}
                                              {{ capitalize(hotel.city_province) }}{{ hotel.city_province ? ',' : '' }}
                                              {{ capitalize(hotel.country_name) }}
                                            </span></p>
                                          </div>
                                        </mat-option>
                                      </ng-container>
                                    </ng-container>
                                  </ng-container>
                                </ng-container>
                              </mat-autocomplete>

                              <!-- Mensajes de error para el autocomplete - CORREGIDO -->
                              <div *ngIf="hotelForm.get('destination').invalid && hotelForm.get('destination').touched"
                                  class="invalid-feedback d-block">
                                <div *ngIf="hotelForm.get('destination').hasError('required')">
                                  Por favor, escriba y seleccione un hotel de la lista
                                </div>
                                <div *ngIf="hotelForm.get('destination').hasError('invalidSelection')">
                                  Debe seleccionar un hotel de la lista desplegable
                                </div>
                              </div>

                              <!-- Botón para volver al modo selector (solo si hay hoteles predefinidos) -->
                              <ng-container *ngIf="hotelsNameArr && hotelsNameArr.length > 0">
                                <p class="mr-1 mb-0 mt-1"
                                  [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                                  style="font-family: 'Rubik';font-size: 12px;cursor:pointer; text-align: end;"
                                  (click)="changeSelectHotel(item)">
                                  Volver a hoteles sugeridos
                                </p>
                              </ng-container>
                            </ng-container>

                          </form>
                        </ng-container>
                      </div>
                    </div>




                      <div *ngIf="item.categoryName === 'INSURANCE'" class="col-8 px-1" >
                          <div class="form-group">

                            <ng-container *ngIf="getInsuranceEmergencyForm(item) as emergencyForm">
                              <form [formGroup]="emergencyForm" class="mt-1">

                                <!-- Fila 1: Nombre | Email -->
                                <div class="row mx-0">
                                  <!-- Nombre del Contacto -->
                                  <div class="col-6 px-1 d-flex flex-column" style="position: relative; padding-bottom: 20px;">
                                    <label for="contactName">Nombre completo del contacto</label>
                                    <input type="text"
                                          id="contactName"
                                          formControlName="contactName"
                                          class="form-control"
                                          [minLength]="3"
                                          [maxLength]="50"
                                          autocomplete="off"
                                          [ngClass]="{'is-invalid': emergencyForm.get('contactName').invalid && emergencyForm.get('contactName').touched}"
                                          placeholder="Nombre y apellido">

                                    <div *ngIf="emergencyForm.get('contactName').invalid && emergencyForm.get('contactName').touched"
                                        class="invalid-feedback d-block ml-1" style="position: absolute; bottom: 0; margin-top: 0;">
                                      <div *ngIf="emergencyForm.get('contactName').hasError('required')">
                                        El nombre es requerido
                                      </div>
                                      <div *ngIf="emergencyForm.get('contactName').hasError('minlength')">
                                        Mínimo 3 caracteres
                                      </div>
                                      <div *ngIf="emergencyForm.get('contactName').hasError('maxlength')">
                                        Máximo 50 caracteres
                                      </div>
                                    </div>
                                  </div>

                                  <!-- Email del Contacto -->
                                  <div class="col-6 px-1 d-flex flex-column" style="position: relative; padding-bottom: 20px;">
                                    <label for="contactEmail">Email del contacto</label>
                                    <input type="email"
                                          id="contactEmail"
                                          formControlName="contactEmail"
                                          class="form-control"
                                          maxlength="100"
                                          autocomplete="off"
                                          [ngClass]="{'is-invalid': emergencyForm.get('contactEmail').invalid && emergencyForm.get('contactEmail').touched}"
                                          placeholder="Ej: contacto@mail.com">

                                    <div *ngIf="emergencyForm.get('contactEmail').invalid && emergencyForm.get('contactEmail').touched"
                                        class="invalid-feedback d-block ml-1" style="position: absolute; bottom: 0; margin-top: 0;">
                                      <div *ngIf="emergencyForm.get('contactEmail').hasError('required')">
                                        El email es requerido
                                      </div>
                                      <div *ngIf="emergencyForm.get('contactEmail').hasError('pattern')">
                                        Formato de email inválido
                                      </div>
                                      <div *ngIf="emergencyForm.get('contactEmail').hasError('maxlength')">
                                        Máximo 100 caracteres
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <!-- Fila 2: Cód. tel. | Teléfono -->
                                  <div class="row mx-0">
                                    <div class="col-4 px-1 d-flex flex-column" style="position: relative; padding-bottom: 20px;">
                                       <label for="contactPhoneCode">Cód. tel.</label>
                                       <!-- <ng-container *ngIf="emergencyForm.get('contactPhoneCode').value === ''"> -->
                                         <input
                                         id="contactPhoneCode"
                                         name="contactPhoneCode"
                                         matInput
                                         class="form-control"
                                         aria-label="contactPhoneCode"
                                         formControlName="contactPhoneCode"
                                         [ngClass]="{'is-invalid': emergencyForm.get('contactPhoneCode').invalid && emergencyForm.get('contactPhoneCode').touched}"
                                         [matAutocomplete]="auto"
                                         (input)="filterCountries($event.target.value)"
                                         (focus)="getCountries()"
                                         (keydown)="blockInvalidKeys($event, 'name')"
                                         autocomplete="off"
                                         placeholder="Cód. tel."
                                       />
                                       <mat-autocomplete
                                         id="matCountry"
                                         #matCountry
                                         #auto="matAutocomplete"
                                         (optionSelected)="updateMySelectionNationality($event.option.value, item)"
                                         [displayWith]="displayCountry"
                                       >
                                         <mat-option *ngFor="let country of filteredCountries" [value]="country.phone_code">
                                           {{ country.country_name }}
                                         </mat-option>
                                       </mat-autocomplete>

                                      <div *ngIf="emergencyForm.get('contactPhoneCode').invalid && emergencyForm.get('contactPhoneCode').touched" class="invalid-feedback d-block ml-1" style="position: absolute; bottom: 0; margin-top: 0; white-space: nowrap;">
                                        <div *ngIf="emergencyForm.get('contactPhoneCode').hasError('required') || emergencyForm.get('contactPhoneCode').hasError('invalidSelection')">
                                          Seleccione un país
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-8 px-1 d-flex flex-column" style="position: relative; padding-bottom: 20px;">
                                        <label for="contactPhone">Teléfono de emergencia</label>
                                        <input type="number" formControlName="contactPhone" id="contactPhone" class="form-control" [ngClass]="{'is-invalid': emergencyForm.get('contactPhone').invalid && emergencyForm.get('contactPhone').touched}" placeholder="Ej: 91112345678">

                                        <div *ngIf="emergencyForm.get('contactPhone').invalid && emergencyForm.get('contactPhone').touched" class="invalid-feedback d-block ml-1" style="position: absolute; bottom: 0; margin-top: 0;">
                                            <div *ngIf="emergencyForm.get('contactPhone').hasError('required')">
                                              El teléfono es requerido
                                            </div>
                                            <div *ngIf="emergencyForm.get('contactPhone').hasError('pattern')">
                                              Formato de teléfono inválido
                                            </div>
                                        </div>
                                    </div>

                                  </div>

                              </form>
                            </ng-container>
                          </div>
                        </div>



                  </div>
                </form>
              </div>

              <!-- Servicio de traslado en tours. Aun a la espera de servicio extra  -->
              <div class="col-12 mb-4">
                <div *ngIf="item.categoryName !== 'INSURANCE'" class="row px-3 " >
                  <ng-container *ngFor="let pax of paxesInItems; let i = index;">
                    <div *ngIf="pax.itemId==item.id" class="d-flex justify-content-space-between mb-2"
                      [ngStyle]="{'margin-right' : (paxesInItems.length < 3) ? '10px' : '0px'}" style="width: 33.33%">
                      <div class="pax-name">
                        <div class="btn d-flex align-items-center" style="background-color: #afeedd;border-radius: 5px; height: 44px">
                          <input type="hidden" id="idpax" [value]="item.id" />
                          <div *ngIf="pax.itemId==item.id" class="">
                              <div class="d-flex align-items-center">
                                <i *ngIf="pax.type === 'CH'" class="icon-child-gray mr-2"></i>
                                <i *ngIf="pax.type !== 'CH'" class="icon-man-gray mr-2"></i>
                                <label style="align-items: center; margin-top: 9px;"> {{pax.first_name}} {{pax.last_name}}
                                  <span style="font-weight: 400;" *ngIf="pax.type !== 'CH' && item.categoryName === 'TOURS' && item.subCategoryId === 6 && i === 0">(Principal)</span>
                                </label>
                              </div>
                          </div>
                          <div *ngIf="item.categoryName=='TOURS'">
                            <input type="hidden" id="{{'idPax-' +pax.idPax}}" [value]="pax.idPax">
                          </div>
                        </div>
                      </div>

                      <div class="delete">
                        <a (click)="removePax(pax.idUnique, pax.itemId, pax)" class="btn ml-1"
                          style="cursor:pointer; background-color: white; border: solid 1px #e0e0e0;;height:44px;width:44px">
                          <i class="icon-cesto"></i>
                        </a>
                      </div>
                      <div *ngIf="item?.additionalDriver" class="d-flex">
                        <span>
                          <label class="custom-radio-checkbox mb-0 mt-2">
                            <input [(ngModel)]="selectedValue" class="custom-radio-checkbox__input" id="{{pax.idPax}}" value="{{pax.idPax}}"
                              type="radio" (click)="additionalDriver(pax.document_number, pax.idPax)">
                            <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span>
                          </label>
                        </span>
                        <label class="pt-1" style="line-height: 15px !important; width: 72px;">Conductor Adicional</label>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <div *ngIf="item.categoryName === 'INSURANCE'"
                      class="px-3 mt-4"
                      [ngClass]="{'row': !item.payload.insurances.paxList[0].hasPreExistingCondition &&
                                         !item.payload.insurances.paxList[0].isOnTrip &&
                                         !item.payload.insurances.paxList[0].isPregntant,
                                  'column': item.payload.insurances.paxList[0].hasPreExistingCondition ||
                                         item.payload.insurances.paxList[0].isOnTrip ||
                                         item.payload.insurances.paxList[0].isPregntant}">

                  <ng-container *ngFor="let pax of paxesInItems; let i = index;">
                    <div *ngIf="pax.itemId==item.id" class="d-flex justify-content-space-between mb-2"
                      [ngStyle]="{'margin-right' : (paxesInItems.length < 3) ? '10px' : '0px',
                                  'width': item.payload.insurances.paxList[0].hasPreExistingCondition ||
                                                              item.payload.insurances.paxList[0].isOnTrip ||
                                                              item.payload.insurances.paxList[0].isPregntant ?
                                                             '100%' : '33.33%'
                                  }">
                      <div class="pax-name" [ngStyle]="{'width': item.payload.insurances.paxList[0].hasPreExistingCondition ||
                                                              item.payload.insurances.paxList[0].isOnTrip ||
                                                              item.payload.insurances.paxList[0].isPregntant ?
                                                              '33%' : 'calc(100% - 53px)'}">
                        <div class="btn d-flex align-items-center" style="background-color: #afeedd;border-radius: 5px; height: 44px">
                          <input type="hidden" id="idpax" [value]="item.id" />
                          <div *ngIf="pax.itemId==item.id" class="">
                              <div class="d-flex align-items-center">
                                <i *ngIf="pax.type === 'CH'" class="icon-child-gray mr-2"></i>
                                <i *ngIf="pax.type !== 'CH'" class="icon-man-gray mr-2"></i>
                                <label style="align-items: center; margin-top: 9px;"> {{pax.first_name}} {{pax.last_name}}</label>
                              </div>
                          </div>
                          <div *ngIf="item.categoryName=='TOURS'">
                            <input type="hidden" id="{{'idPax-' +pax.idPax}}" [value]="pax.idPax">
                          </div>
                        </div>
                      </div>

                      <div class="delete">
                        <a (click)="removePax(pax.idUnique, pax.itemId, pax)" class="btn ml-1"
                          style="cursor:pointer; background-color: white; border: solid 1px #e0e0e0;;height:44px;width:44px">
                          <i class="icon-cesto"></i>
                        </a>
                      </div>
                      <div class="pl-1" style="width: 100%" *ngIf="item.payload.insurances.paxList[0].hasPreExistingCondition ||
                                                              item.payload.insurances.paxList[0].isOnTrip ||
                                                              item.payload.insurances.paxList[0].isPregntant">

                       <select name="" id="" class="form-control"
                              (change)="selectedConditionInPax(item, pax, $event.target.value)"
                              style="width: 100%;height: 44px;">
                        <option selected disabled value="null">Condiciones</option>
                        <ng-container *ngFor="let condition of getConditionsInsurances(item, pax)">
                          <option value="{{condition | json}}"
                                  [selected]="isConditionSelected(condition, pax)">
                            {{condition.label}}
                          </option>
                        </ng-container>
                      </select>
                      </div>
                    </div>

                  </ng-container>


                </div>


              </div>

              <div class="col-12 px-3 mb-3" *ngIf="item.categoryName=='TRANSPORTS' && needsFlight(item)">
                <form [formGroup]="getFlightForm(item)">
                    <div class="form-group" style="position: relative">
                      <label for="fly-{{item.id}}">Seleccionar vuelo</label>

                      <select class="form-control custom-select btn-usb-rp element-config-passenger"
                              style="height: 38px !important"
                              formControlName="selectedFlight"
                              id="fly-{{item.id}}">

                        <option [ngValue]="null" disabled>Seleccione una opción</option>

                        <optgroup label="Nacionales" *ngIf="getNationalFlights(item).length">
                          <option *ngFor="let flight of getNationalFlights(item)"
                                  [ngValue]="flight">
                                 {{ getFlyInfoOptionTemplate(flight, item)}}
                          </option>
                        </optgroup>

                        <optgroup label="Internacionales" *ngIf="getInternationalFlights(item).length">
                          <option *ngFor="let flight of getInternationalFlights(item)"
                                  [ngValue]="flight">
                                 {{ getFlyInfoOptionTemplate(flight, item)}}
                          </option>
                        </optgroup>

                      </select>

                      <div *ngIf="getFlightControl(item).invalid && getFlightControl(item).touched"
                          class="invalid-feedback d-block ml-1" style="position: absolute;bottom: -22px">
                          <div *ngIf="getFlightControl(item).hasError('required')">
                              El vuelo es necesario
                          </div>
                      </div>
                    </div>
                  </form>
                </div>
              <div class="col-12 ml-1 mb-5">
                <div class="d-flex flex-column">
                  <div class="d-flex flex-column">
                    <p class="font-weight-bold mb-2"
                       style="font-family: 'Rubik', sans-serif;font-size: 14px"
                    >
                      <span *ngIf="(item.categoryName == 'HOTELS' || item.categoryName == 'PARKS')">Peticiones al establecimiento (solo indicativas)</span>
                      <span *ngIf="item.categoryName == 'TRANSPORTS'">Peticiones al traslado (solo indicativas)</span>
                    </p>
                    <div class="mb-4 row" *ngIf="(item.categoryName == 'HOTELS' || item.categoryName == 'PARKS')">
                      <span *ngFor="let remark of remarks"
                            class="col-lg-3 col-md-2 d-flex align-items-center mb-2"
                      >
                          <input
                                class="mr-2"
                                type="checkbox"
                                (change)="requestRoomHotel(item, remark.name)"

                          />
                          <p style="font-size: 12px;margin-bottom: 0px;">{{remark.name}}</p>
                      </span>
                    </div>
                    <!-- <div class="mb-4" *ngIf="(item.categoryName == 'HOTELS' || item.categoryName == 'PARKS') && item?.room.remarks && item?.room.remarks.length > 0">
                      <p class="font-weight-bold mb-0"
                       style="font-family: 'Rubik', sans-serif;font-size: 14px">
                       Remarks
                      <p  class="mb-0" style="font-size: 12px;">
                          {{getRemarksItem(item?.room?.remarks)}}
                    </div> -->
                    <div class="mb-4" *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 6 && item?.additionalInfo?.remarks && item?.additionalInfo?.remarks.length > 0">
                      <p *ngIf="getQuestionsExists(item, 'EMAIL')" class="font-weight-bold mb-3"
                       style="font-family: 'Rubik', sans-serif;font-size: 14px">
                       Email: <span style="font-weight: 400;">{{getDataPaxInItems(item, 'EMAIL')}}</span>
                      </p>
                      <p *ngIf="getQuestionsExists(item, 'PHONENUMBER')" class="font-weight-bold mb-3"
                       style="font-family: 'Rubik', sans-serif;font-size: 14px">
                       Teléfono: <span style="font-weight: 400;">{{getDataPaxInItems(item, 'PHONENUMBER')}}</span>
                      </p>
                      <p *ngIf="getQuestionsExists(item, 'HOTEL')" class="font-weight-bold mb-3"
                       style="font-family: 'Rubik', sans-serif;font-size: 14px">
                       Hotel: <span style="font-weight: 400;">{{getSelectedHotelForm(item)}}</span>
                      </p>
                      <p class="font-weight-bold mb-0"
                       style="font-family: 'Rubik', sans-serif;font-size: 14px">
                       Remarks
                      </p>
                        <p  class="mb-0" style="font-size: 12px;">
                          {{getRemarksItem(item?.additionalInfo?.remarks)}}
                        </p>

                         <p *ngIf="item.comments_provider" class="font-weight-bold mb-0 mt-3"
                       style="font-family: 'Rubik', sans-serif;font-size: 14px">
                       Detalles del servicio
                      </p>
                        <p *ngIf="item.comments_provider"  class="mb-0" style="font-size: 12px;" [innerHtml]="getCommentsProviderInner(item.comments_provider)">
                        </p>
                    </div>
                  </div>
                    <textarea class="textarea-comments"
                              name=""
                              id=""
                              cols="85"
                              rows="5"
                              placeholder="Comentarios"
                              (input)="requestCommentHotel(item, $event.target.value)"
                    ></textarea>
                    <p *ngIf="(item.categoryName == 'HOTELS' || item.categoryName == 'PARKS')" class="mt-2 mx-2" style="font-size: 12px;margin-bottom: 0px;">Los requerimientos son enviados al hotel junto con la reserva.  Ninguno es considerado una confirmación y cada uno esta sujetos a confirmación y aprobación por parte del hotel.</p>
                    <p *ngIf="item.categoryName == 'RENT-A-CAR'" class="mt-2 mx-2" style="font-size: 12px;margin-bottom: 0px;">Los requerimientos son enviados al servicio de rent-a-car junto con la reserva.  Ninguno es considerado una confirmación y cada uno esta sujetos a confirmación y aprobación por parte del servicio de rent-a-car.</p>
                    <p *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 6" class="mt-2 mx-2" style="font-size: 12px;margin-bottom: 0px;">Los requerimientos son enviados al traslado junto con la reserva.  Ninguno es considerado una confirmación y cada uno esta sujetos a confirmación y aprobación por parte del traslado.</p>
                    <p *ngIf="item.categoryName == 'TOURS' && item.subCategoryId === 9" class="mt-2 mx-2" style="font-size: 12px;margin-bottom: 0px;">Los requerimientos son enviados al servicio de ticket junto con la reserva.  Ninguno es considerado una confirmación y cada uno esta sujetos a confirmación y aprobación por parte del servicio de la experiencia.</p>
                    <p *ngIf="item.categoryName == 'TRANSPORTS'" class="mt-2 mx-2" style="font-size: 12px;margin-bottom: 0px;">Los requerimientos son enviados al servicio de traslado junto con la reserva.  Ninguno es considerado una confirmación y cada uno esta sujetos a confirmación y aprobación por parte de traslado.</p>
                    <p *ngIf="item.categoryName == 'INSURANCE'" class="mt-2 mx-2" style="font-size: 12px;margin-bottom: 0px;">Los requerimientos son enviados a la asistencia junto con la reserva.  Ninguno es considerado una confirmación y cada uno esta sujetos a confirmación y aprobación por parte de la asistencia.</p>
                </div>
              </div>
            </div>
          </accordion-group>
        </accordion>
      </div>
    </div>
  </div>
  <div class="col-4">
    <span class="mb-3 px-2" style="font-size: 1.65rem;" [ngStyle]="{'color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">SUMMARY</span>
    <div class="sidebar p-2 pb-5"  [ngStyle]="{ 'background-color': styleSidebar?.background_color }">
      <usb-summary-reservation
                                  [currencies]="currencies"
                                  [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                                  [currencyAgency]="currencyAgency"
                                  [itineraryItems]="itineraryItems"
                                  [itineraryTotal]="itineraryTotal"
                                  [styleSidebar]="styleSidebar"
                                  [itinerary]="itinerary">
      </usb-summary-reservation>
      <!-- <div class="d-flex"> -->
        <button
          (click)="_onSubmit();"
          [disabled]='reserving'
          class="btn btn-block d-flex align-items-center justify-content-center gap-2"
          style="font-family: 'Rubik'; font-size: 19px; font-weight: 500; border-radius: 50rem; cursor: pointer; height: 70px; transition: opacity 0.3s ease;"
          [ngStyle]="{'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_3, 'opacity': reserving ? 0.7 : 1}">
          <i *ngIf="reserving" class="fas fa-sync-alt fa-spin mr-2"> </i>
          {{ reserving ? 'PROCESANDO' : 'RESERVAR' }}
        </button>
        <span style="font-size: 0.8em; margin-left: 15px;" [ngStyle]="{ 'color': styleSidebar?.color }">Regresar para modificar los datos del formulario</span>
        <button (click)="_return()" class="btn btn-block" style="height: 45px;border-radius: 50rem; cursor: pointer; background-color: #afeedd">
          <span>REGRESAR</span>
        </button>
      <!-- </div> -->

    </div>
  </div>
</div>

<usb-itinerary-detail style="display:none"
                      #itineraryDetail
                      [appLoading]="appLoading"
                      [results]="results"
                      [itemsSync]="itemsSync"
                      [itineraryId]="itineraryId"

                      (shouldContinueEvent)="shouldContinue($event)">
</usb-itinerary-detail>
